import { HeadingItem } from 'components'
import { ItemDetailInfo } from 'components/item-verification'
import React, { FC, useContext } from 'react'
import { TripContext } from "contexts";
import './verify-returnitem-details.scss'
import { LineItem, ReturnItem } from 'services/types';

type Props = {
    returnItemId: number
}

export const VerifyReturnItemDetails: FC<Props> = ({ returnItemId }) => {

    const tripContext = useContext(TripContext)

    const returnItem: ReturnItem = tripContext.returnItems.find(item => item.id === returnItemId) ?? {} as ReturnItem
    // Business rule: docs/application_design/business_rules/return-item-verification-business-rules.md#br-return-item-verification-001
    // Show the authorization number from the order associated with this return item.
    const authorizationNumber = tripContext.orders.find(order => order.id === returnItem.orderId)?.orderNumber ?? returnItem.orderId
    const lineItem: LineItem = tripContext.lineItems.find(item => item.id === returnItem.lineItemId) ?? {} as LineItem

    return (
        <div className={'card-material'}>
            <HeadingItem text={`Authorization No : ${authorizationNumber ?? 'N/A'}`} />
            <div className={'verify-item-details-description'}>{lineItem.longDescription ?? (lineItem.description ?? 'No description available')}</div>
            <div className={'verify-item-details'}>
                <ItemDetailInfo title={'Item ID'} value={lineItem.id} position={'left'} />
                <ItemDetailInfo title={'Manufacturer Item ID'} value={lineItem.manufacturerItemId} position={'left'} />
            </div>
        </div>
    )
}
